<template>
  <page-content>
    <div class="col-middle">
      <div class="text-center text-center">
        <h1 class="error-number"><i class="fad fa-spinner fa-pulse"></i></h1>
        <h2>Đăng nhập thành công!</h2>
        <p>
          Hệ thống đang chuyển đến trang bạn yêu cầu
          <br/>
          Vui lòng đợi trong ít phút...
        </p>
        <div class="mid_center">
          <h3></h3>
        </div>
      </div>
    </div>
  </page-content>
</template>

<script>
import {GhtkAuth, OAuth2CallbackHandler} from 'gmjs'
import oidc from "@/oidc";

export default {
  name: "Callback",
  async mounted() {
    try {
      const handler = OAuth2CallbackHandler(oidc)
      if (await handler.handle()) {
        // Login successfully

        // Get token for jquery ajax
        const ghtkAuth = new GhtkAuth(oidc);
        const tokenInfo = await ghtkAuth.tokenManager.get('accessToken');
        const accessToken = tokenInfo ? tokenInfo.accessToken : '';
        $.ajaxSetup({
          headers: {
            "Authorization": `Bearer ${accessToken}`
          },
        });

        // Get permission của user
        this.$http.get('/cms/api/v1.0/user/permissions')
            .then(success => {
              localStorage.setItem("permissions", JSON.stringify(success.data));
            })
            .catch(this.errorNotify)
        await this.$router.push(handler.getRefererPath() || '/')
      } else {
        this.$error('Đăng nhập không thành công');
        await this.$router.push('/');
      }
    } catch (e) {
      // Handle exception here
      console.error(e)
      this.$error(e.message);
      await this.$router.push('/');
    }
  }
}
</script>

<style scoped>

</style>